import React from 'react';
import PropTypes from 'prop-types';

const ChevronDown = ({ direction = 'down', fill = 'var(--PRIMARY)' }) => (
  <svg
    width="15px"
    height="10px"
    viewBox="0 0 15 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />
    <desc />
    <g
      id="Visual-design"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="File-Status-"
        transform="translate(-866.000000, -128.000000)"
        fill={fill}
        fillRule="nonzero"
      >
        <g id="Group-16" transform="translate(781.000000, 112.000000)">
          <g id="Group-3-Copy" transform="translate(0.000000, 1.000000)">
            <g
              id="back-arrow"
              transform={`translate(92.000000, 20.000000) rotate(${
                direction === 'down' ? '-360.000000' : '-180.000000'
              }) translate(-92.000000, -20.000000) translate(84.000000, 12.000000)`}
            >
              <g>
                <path
                  d="M10.5808034,1.18643121 C10.9891948,0.789708116 11.6513281,0.789708116 12.0597195,1.18643121 C12.4466166,1.56227413 12.4669796,2.15934545 12.1208085,2.55847558 L12.0597195,2.6230926 L6.52496732,8 L12.0597195,13.3769074 C12.4466166,13.7527503 12.4669796,14.3498216 12.1208085,14.7489518 L12.0597195,14.8135688 C11.6728224,15.1894117 11.0581901,15.2091929 10.6473209,14.8729124 L10.5808034,14.8135688 L4.30629356,8.7183307 C3.91939643,8.34248777 3.89903342,7.74541645 4.24520454,7.34628633 L4.30629356,7.2816693 L10.5808034,1.18643121 Z"
                  transform="translate(8.183007, 8.000000) rotate(-90.000000) translate(-8.183007, -8.000000) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

ChevronDown.propTypes = {
  fill: PropTypes.string,
  direction: PropTypes.string,
};

export default ChevronDown;
